var moment = require("moment-timezone");
import store from "../store";
import { content } from "../../config/config";

export default {
  install(Vue) {
    const DATETIME_FORMAT = moment.tz.guess().split("/")[0] == "America" ? "MM/DD/YYYY, HH:mm" : "DD/MM/YYYY, HH:mm";
    const DATE_FORMAT = moment.tz.guess().split("/")[0] == "America" ? "MM/DD/YYYY" : "DD/MM/YYYY";
    const DEFAULT_TEMPERATURE_UNIT = moment.tz.guess().split("/")[0] == "America" ? "fahrenheit" : "celsius";
    const trim_date_time = (date, actual_date) => {
      var roundDown = (d) => d && d.startOf("minute");
      var roundUp = (d) => (d.second() || d.millisecond() ? d.add(1, "minute").startOf("minute") : d.startOf("minute"));
      let roundedDate = actual_date && actual_date.second() > 30 ? roundUp(date) : roundDown(date);
      return date ? roundedDate.format(DATETIME_FORMAT) : "None";
    };
    const TIMESINCE = (seconds) => {
      var interval = Math.floor(seconds / 31536000);
      if (seconds == -1) {
        return "None";
      }
      if (interval > 1) {
        return interval + " years";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes";
      }
      if (seconds > 1) {
        return Math.floor(seconds) + " seconds";
      }
      if (seconds != 0) return Math.floor(seconds * 1000) + " ms";
      else return "-";
    };
    Vue.filter("timeSince", (value) => {
      // Value in hours
      var seconds = (value && value * 60 * 60) || -1;
      return TIMESINCE(seconds);
    });
    Vue.filter("timeSinceMs", (value) => {
      // value in ms
      var seconds = (value && value / 1000) || -1;
      return TIMESINCE(seconds);
    });
    Vue.filter("date", (value) => {
      let date = value ? moment(new Date(value).toISOString()) : null;
      let actual_date = value ? moment(new Date(value).toISOString()) : null;
      return trim_date_time(date, actual_date);
    });
    Vue.filter("epochCon", (value) => {
      let date = moment(Number(value));
      let actual_date = moment(Number(value));
      return value ? trim_date_time(date, actual_date) : "-";
    });
    Vue.filter("epochToIso", (value) => {
      return value ? moment(Number(value)).toISOString() : "-";
    });
    Vue.filter("round", (value, decimal) => {
      return typeof value == "number" ? value.toFixed(decimal ? (decimal == -1 ? 0 : decimal) : 2) : "None";
    });
    Vue.filter("rounded", (value) => {
      return typeof value == "number" ? value.toFixed(2) : "-";
    });
    Vue.filter("hours", (value) => {
      return value < 12 ? `${value} AM` : `${12 - value} PM`;
    });
    Vue.filter("toFahrenheit", (value) => {
      return parseFloat((value * 9) / 5 + 32);
    });
    Vue.filter("toUserSelectedTempMetric", (value) => {
      if (store.state.user_config && store.state.user_config.temperature_metric == "fahrenheit") {
        return Math.round(parseFloat((value * 9) / 5 + 32));
      }
      return Math.round(parseFloat(value));
    });
    Vue.filter("temperatureSuffix", () => {
      //Returns the suffix (°C or °F) based on the user's selected metric
      //Uses user_config.temperature_metric to lookup the corresponding suffix in `content.TemperatureMetric`
      return store.state.user_config
        ? content.TemperatureMetric[store.state.user_config.temperature_metric].suffix
        : null;
    });
    Vue.filter("assignTemperatureMetric", () => {
      // Determine temperature unit based on timezone region
      // America → Fahrenheit, Elsewhere → Celsius
      return DEFAULT_TEMPERATURE_UNIT;
    });
    Vue.prototype.$dateToIso = (value) => {
      // This function converts 2024-01-01 to Mon May 27 2024 23:59:59 GMT+???? (GMT+??:??)
      let date = new Date(value);
      date.setHours(23, 59, 59);
      return date;
    };
    Vue.prototype.$dateToEpoch = (value) => {
      // This function converts 2024-01-01 to 1735689599000
      return new Date(value).getTime();
    };
    Vue.prototype.$emptyCheck = (text) => {
      return typeof text == "number" ? text : text || "None";
    };
    Vue.prototype.$epochConverter = (text) => {
      return typeof text == "number" ? moment.unix(text).format() : moment.unix(+text).format() || "None";
    };
    Vue.prototype.$dateFormat = (value) => {
      if (!value) return "-";
      return moment(value).format("YYYY-MM-DD");
    };
    Vue.prototype.$formatDate = (value) => {
      return value
        ? typeof value == "string"
          ? moment(String(value)).format(DATE_FORMAT)
          : moment(value).format(DATE_FORMAT)
        : "-";
    };
    Vue.prototype.$formatDateTime = (value) => {
      let date = value ? moment(Number(value)) : null;
      let actual_date = value ? moment(Number(value)) : null;
      return trim_date_time(date, actual_date);
    };
    Vue.prototype.$numberFormat = (value) => {
      return typeof value == "number" ? value.toFixed(2) : "None";
    };
    Vue.prototype.$emptyCheckNoReturn = (text) => {
      return text || "";
    };
    Vue.prototype.$timestampToEpoch = (text) => {
      return moment(text).valueOf() || "";
    };
    Vue.prototype.$numberWithCommas = (x) => {
      return (x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) || "";
    };
    Vue.prototype.$percentage = (x) => {
      return (x == 0 && "0%") || (x && Math.round(x * 10000) / 100 + "%") || "";
    };
    Vue.prototype.$percentageOf = (x, y) => {
      if (!x || !y) return null;
      return ((x / y) * 100).toFixed(0);
    };
    Vue.prototype.$formatDateAsOf = (value) => {
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    Vue.prototype.$formatDateFormat = (value) => {
      // This function returns the date from YYYY-MM-DD to DD/MM/YYYY
      if (!value) return "-";
      return value.split("-").reverse().join("/");
    };
  },
};
